var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":require('@/assets/images/logo/logo-the-fives-2.svg'),"alt":"The Fives"}})])}
var staticRenderFns = []

export { render, staticRenderFns }